import Box from '@mui/material/Box';
import { DateField } from '@mui/x-date-pickers/DateField';
import { usePickerContext } from '@mui/x-date-pickers/hooks';
import {
  pickersLayoutClasses,
  PickersLayoutContentWrapper,
  PickersLayoutProps,
  PickersLayoutRoot,
  usePickerLayout
} from '@mui/x-date-pickers/PickersLayout';
import { useState } from 'react';

const LayoutWithKeyboardView = (props: PickersLayoutProps<Date | null>) => {
  const { value, setValue, variant } = usePickerContext<Date | null>();
  const [showKeyboardView, setShowKeyboardView] = useState(false);

  const { toolbar, tabs, content, actionBar, ownerState } = usePickerLayout({
    ...props,
    slotProps: {
      ...props.slotProps,
      toolbar: {
        ...props.slotProps?.toolbar,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        showKeyboardViewSwitch: variant === 'mobile',
        showKeyboardView,
        setShowKeyboardView
      }
    }
  });

  return (
    <PickersLayoutRoot ownerState={ownerState}>
      {toolbar}
      {actionBar}
      <PickersLayoutContentWrapper className={pickersLayoutClasses.contentWrapper} ownerState={ownerState}>
        {tabs}
        {showKeyboardView ? (
          <Box sx={{ mx: 3, my: 2, width: 272 }}>
            <DateField
              value={value}
              onChange={(newValue) => setValue(newValue, { changeImportance: 'set' })}
              sx={{ width: '100%' }}
            />
          </Box>
        ) : (
          content
        )}
      </PickersLayoutContentWrapper>
    </PickersLayoutRoot>
  );
};

export default LayoutWithKeyboardView;
